import React from "react";
import {Box, Heading, Form, FormField, TextInput, Button, Select, CheckBox, Text} from "grommet";
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { useLazyQuery,useMutation } from '@apollo/client';
import {extractIdFormData, GOLF_ADD_ATTACHMENT, GOLF_GET_ATTACHMENT, QUERY_CONTENT_TYPE} from "../../../utilis/utils";
import moment from "moment";
import {QUERY_AREE, UPSERT_PACKAGE} from "./PackageGQL.js";
import {QUERY_PACKAGE_AREA_LIST} from "./PackageGQL.js";

export default function AddPackage(props) {

  const [formData,setFormData]=React.useState({"number_of_entry":0})
  const [checked_entrate, setChecked_entrate] = React.useState(formData?.solar_package ? false: formData?.number_of_entry!=null && formData?.duration_in_days==null && formData?.duration_in_month==null);
  const [checked_durata_giorni, setChecked_durata_giorni] = React.useState(formData?.solar_package ? false: formData?.duration_in_days!=null);
  const [checked_durata_mesi, setChecked_durata_mesi] = React.useState(formData?.solar_package ? false: formData?.duration_in_month!=null);
  const [checked_solar_year,setChecked_solar_year] = React.useState(formData?.solar_package);
  const [mutationUpsertPack]=useMutation(UPSERT_PACKAGE);
  const [areeList,setAreeList] = React.useState([]);
  const [selectedAree,setSelectedAree] = React.useState([]);
  const [ queryGetAree
  ]  = useLazyQuery(QUERY_AREE, {
  fetchPolicy: "no-cache",
    onCompleted: (data) => {
      if(data["clubmate_clubmatearea_clubmatearea"]){
        setAreeList(data["clubmate_clubmatearea_clubmatearea"]);
      }
    },
    onError:(error)=>{
      console.log(error);
    },
    notifyOnNetworkStatusChange: true, // did the work
  });

  const [ queryPackageList
  ]  = useLazyQuery(QUERY_PACKAGE_AREA_LIST, {
  fetchPolicy: "no-cache",
    onCompleted: (data) => {
      if(data["clubmate_clubmatearea_clubmatearea"]){
        setSelectedAree(data["clubmate_clubmatearea_clubmatearea"]);
      }
    },
    onError:(error)=>{
      console.log(error);
    },
    notifyOnNetworkStatusChange: true, // did the work
  });

    function onUpsertPack(){
    let obj= extractIdFormData(formData,true,true);
    delete obj?.variables?.input["_Typename"]
    obj.variables.input["aree"]=JSON.stringify(selectedAree.map((area)=>area?.id))
      console.log("OBJ",obj)
    mutationUpsertPack(obj)
    .then((value)=>{
      alert("Pacchetto aggiunto correttamente");
      onEscLayer();
    }).catch((value)=>{
      console.error(value);
      alert("Errore durante l'operazione");
    })
  }

      React.useEffect(() =>{
        queryGetAree();
        if(props?.elementSel){
          queryPackageList({variables:{packageId:props?.elementSel?.id}});
          setFormData(props?.elementSel)
          if(props?.elementSel?.duration_in_days){
            setChecked_durata_giorni(true)
            setChecked_entrate(false)
            setChecked_durata_mesi(false)
            setChecked_solar_year(false);
          }
          if(props?.elementSel?.number_of_entry){
            setChecked_durata_giorni(false)
            setChecked_entrate(true)
            setChecked_durata_mesi(false)
            setChecked_solar_year(false);
          }
          if(props?.elementSel?.duration_in_month){
            setChecked_durata_giorni(false)
            setChecked_entrate(false)
            setChecked_durata_mesi(true)
            setChecked_solar_year(false);
          }
          if(props?.elementSel?.solar_package){
            setChecked_durata_giorni(false)
            setChecked_entrate(false)
            setChecked_durata_mesi(false)
            setChecked_solar_year(true);
          }
        }
      },[])

      const handleEntrateChange = (event) => {
        setChecked_entrate(event.target.checked);
        if (event.target.checked) {
          setChecked_durata_giorni(false);
          setChecked_durata_mesi(false);
          setChecked_solar_year(false);
          setFormData({...formData,duration_in_days:null, duration_in_month:null,solar_package:false})
        }
      };

    const handleSolarYearChange = (event) => {
      setChecked_solar_year(event.target.checked);
      if (event.target.checked) {
        setChecked_durata_giorni(false);
        setChecked_durata_mesi(false);
        setChecked_entrate(false);
        setFormData({...formData,duration_in_days:null,duration_in_month:null,solar_package:event.target.checked})
      }
    };
    
      const handleDurataGiorniChange = (event) => {
        setChecked_durata_giorni(event.target.checked);
        if (event.target.checked) {
          setChecked_entrate(false);
          setChecked_durata_mesi(false);
          setFormData({...formData,number_of_entry:null, duration_in_month:null,solar_package:false})
        }
      };

      const handleDurataMesiChange = (event) => {
        setChecked_durata_mesi(event.target.checked);
        if (event.target.checked) {
          setChecked_entrate(false);
          setChecked_durata_giorni(false);
          setChecked_solar_year(false);
          setFormData({...formData,number_of_entry:null, duration_in_days:null,solar_package:false})
        }
      };

  function onEscLayer(){
    if(props.onEscLayer){
        props.onEscLayer();
    }
    setFormData({});
  }

  const onChangeTextInput=(event)=>{
    if(event.target.type==="number"){
      setFormData({...formData,[event.target.name]:parseFloat(event.target.value)})
    }else if(event.target.type==="date"){
      setFormData({...formData,[event.target.name]:moment(event.target.value).format("YYYY-MM-DD")})
    }else{
      setFormData({...formData,[event.target.name]:event.target.value})
    }
  }


  function handleChange(option){
      setSelectedAree(option);
  }


  return (
    <Box height="100%" round pad="medium" direction="column" background="#ffffff" align="center" overflow="auto">
      <Heading level="2" margin="none" size="small" style={{fontWeight:'bold',textTransform: 'uppercase'}}>
        <Box direction="row" gap="large">
          {!props.elementSel?"Inserisci pacchetto":"Aggiorna pacchetto"}
          {/*<Button label="Scarica modello" href={"./modelliCsv/Modello_Personale.csv"} style={{width:'200px',fontSize:'20px',background:'#f8b20e',color:'white',fontWeight:'bold',textTransform: 'uppercase',textAlign:"center"}}></Button>  */}
        </Box>
      </Heading>
      <Box fill gap="medium" pad={{ vertical: "small" }} align="center">
        <Form style={{marginTop:"50px"}}>
        <Box direction="row" align="center">
          <Box pad="xsmall">
            <FormField required label="Nome">
              <TextInput
                style={{fontWeight:"bold"}}
                name="name"
                value={formData?.name}
                onChange={e => onChangeTextInput(e)}
              />
            </FormField>
          </Box>
          <Box pad="xsmall">
            <FormField required label="Prezzo">
              <TextInput
                style={{fontWeight:"bold"}}
                placeholder="es. 10,5"
                type="number"
                name="price"
                value={formData?.price}
                onChange={e => onChangeTextInput(e)}
              />
            </FormField>
          </Box>
        </Box>
        <Box  direction="column" style={{marginTop:15+"px"}}>
        <Text>Tipologia pacchetto</Text>
          <Box margin={"small"}>
            <CheckBox
                checked={checked_solar_year}
                label="Anno solare"
                onChange={handleSolarYearChange}
                className="checkbox_solar_year"
            />
          </Box>
        <div style={{display:"flex",flexDirection:"row",marginTop:20+"px",paddingLeft:10+"px",gap:30+"px"}}>
          <CheckBox
            checked={checked_entrate}
            label="Per entrate"
            onChange={handleEntrateChange}
            className="checkbox entrate"
          />
          <CheckBox
            checked={checked_durata_giorni}
            label="Per giorni"
            onChange={handleDurataGiorniChange}
            className="checkbox durataGiorni"
          />
          <CheckBox
            checked={checked_durata_mesi}
            label="Per mesi"
            onChange={handleDurataMesiChange}
            className="checkbox durataMesi"
          />
          </div>
        </Box>
        <Box  direction="row" align="center" style={{marginTop:15+"px"}}>
          {checked_entrate && (<Box class="pacchetto_entrate" pad="xsmall">
              <FormField required label="Numero di entrate">
                <TextInput
                    type="number"
                  style={{fontWeight:"bold"}}
                  name="number_of_entry"
                  value={formData?.number_of_entry}
                  onChange={e => onChangeTextInput(e)}
                />
              </FormField>
            </Box>)}
          {checked_durata_giorni &&(<Box pad="xsmall">
            <FormField required label="Giorni di durata">
              <TextInput
                style={{fontWeight:"bold"}}
                type="number"
                name="duration_in_days"
                value={formData?.duration_in_days}
                onChange={e => onChangeTextInput(e)}
              />
            </FormField>
          </Box>)}

          {checked_durata_mesi &&(<Box class="pacchetto_durata"  pad="xsmall">
            <FormField required label="Mesi di durata">
              <TextInput
                style={{fontWeight:"bold"}}
                type="number"
                name="duration_in_month"
                value={ formData?.duration_in_month}
                onChange={e => onChangeTextInput(e)}
              />
            </FormField>
          </Box>)}    
        </Box>
        <Box  direction="column" style={{marginTop:15+"px"}}>
          <Autocomplete
            multiple
            disablePortal
            id="aree"
            value={selectedAree}
            getOptionKey={(option) => option?.id}
            getOptionLabel={(option) => option?.name}
            options={areeList}
            sx={{ width: 300 }}
            renderInput={(params) => <TextField {...params} label="Aree del pachetto" />}
            onChange={(event, value) => handleChange(value)}
          />
        </Box>
      </Form>
      <Box direction="row" gap="medium" alignSelf="center" style={{marginTop:"20px"}}>
          <Button label={!props.elementSel?"Aggiungi":"Aggiorna"} onClick={onUpsertPack} style={{width:'170px',height:'34px',fontSize:'18px',background:'#f8b20e',color:'white',fontWeight:'bold',textTransform: 'uppercase'}}/>
      </Box>
      </Box>

    </Box>
  )
}

/*
<Select
            options={areeList}
            value={selectedAree}
            multiple={true}
            labelKey={"name"}
            valueKey={"name"}
            closeOnChange={false}
            onChange={( option ) => handleChange(option)}
          />
*/